import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Branches from "../components/Branches";
import Footer from "../components/Footer";
import GeneralInfo from "./GeneralInfo";
import StaffTeaching from "./StaffTeaching";
import SchoolInfrastructure from "./SchoolInfrastructure";
import ContactSection from "./ContactSection";

import StatsSection from "../components/StatsSection";
import NoticeBoard from "../components/NoticeBoard";
import GalleryPreview from "../components/GalleryPreview";

function Home() {
  return (
    <>
      {/* <Header /> */}
      <Hero />
      {/* <About /> */}
      {/* <Branches /> */}
      <GeneralInfo />
      <StaffTeaching />
       <StatsSection />
      <NoticeBoard />
      {/* <GalleryPreview /> */}
      <SchoolInfrastructure />
      <ContactSection />
      {/* <Footer /> */}
    </>
  );
}

export default Home;